import React from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { debounce } from 'lodash';
import { DragItem, IDraggableItemProps, IDragSortListWrapProps } from './type';

const DraggableItem = ({ data, index, onDragEnd, item }: IDraggableItemProps) => {
  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: 'item',
    item: () => ({ type: 'item', id: index }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  const [, dropRef] = useDrop({
    accept: 'item',
    hover: (item: DragItem) => {
      const dragIndex = item.id;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      onDragEnd({
        source: {
          index: dragIndex,
        },
        destination: {
          index: hoverIndex,
        },
      });
    },
  });

  return (
    <div ref={(node) => { dragRef(dropRef(node)); }} style={{ opacity: isDragging ? 0.4 : 1 }}>
      {item(data, index)}
    </div>
  );
};

const DragSortListWrap = ({ list, onDragEnd, item }: IDragSortListWrapProps): JSX.Element => {
  const debouncedOnDragEnd = debounce(onDragEnd, 250);

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="sortable-list">
        {list.map((data, index) => (
          <DraggableItem key={index} data={data} index={index} onDragEnd={debouncedOnDragEnd} item={item} />
        ))}
      </div>
    </DndProvider>
  );
};

export default DragSortListWrap;
